import { ICustomTheme } from '../theme';

const theme: ICustomTheme = {
  'color.bg': '#282a36',
  'color.offBg': '#303240',
  'color.font': '#f8f8f2',
  'color.offFont': '#f8f8f2',
  'color.border': '#40414d',
  'color.offBorder': '#383942',
  'color.headerBg': '#303240',
  'color.editor.comment': '#6272a4',
  'color.editor.string': '#f1fa8c',
  'color.editor.number': '#bd93f9',
  'color.editor.variable': '#50fa7b',
  'color.editor.attribute': '#ff79c6',
  'color.editor.keyword': '#ff79c6',
  'color.editor.atom': '#bd93f9',
  'color.editor.property': '#bd93f9',
  'color.editor.punctuation': '#f8f8f2',
  'color.editor.cursor': '#f8f8f2',
};

export default theme;
